export const saveReviewNotesAddressedMutation = /* GraphQL */ `
  mutation SaveReviewNotesAddressed($input: SaveReviewNotesAddressedInput!) {
    saveReviewNotesAddressed(input: $input) {
      status
      details
      error {
        message
      }
    }
  }
`;

export const getReviewNotesAddressedStatusQuery = /* GraphQL */ `
  query GetReviewNotesAddressedStatus($committeeId: String!, $keys: String!) {
    getReviewNotesAddressedStatus(committeeId: $committeeId, keys: $keys) {
      status
      items {
        applicantEmployeeId
        readerEmployeeId
        term
        addressed
        addressedBy
        addressedDatetime
      }
      error {
        message
      }
    }
  }
`;
